import type { Sponsor } from './api';

/**
 * 8Ball's own sponsors, less the ones this league already shows as its own.
 *
 * A business that backs both the platform and the league in front of you should
 * appear once on the page, in the league's strip, not twice under two headings.
 *
 * This used to compare row ids, and that was right for exactly as long as a
 * shared sponsor was one row: Mzansi Gold backed Society, was flagged
 * `featured_on_platform`, and the same record came back from both queries. A
 * sponsor row belongs to one league, though, so the day Mzansi Gold also backed
 * Norwood it became a second row — a different id, the same business, printed
 * twice down the same footer.
 *
 * Matched on name, trimmed and case-folded, which is how the database itself
 * identifies a sponsor across leagues: migrations 020, 021 and 048 all find
 * these businesses by name. Two genuinely different sponsors sharing a name
 * would collapse into one here, and that is the better failure — the alternative
 * is one advertiser appearing twice on the page they paid to be on once.
 */
export function platformOnly(platform: Sponsor[], own: Sponsor[]): Sponsor[] {
  const key = (s: Sponsor) => s.name.trim().toLowerCase();
  const ours = new Set(own.map(key));
  return platform.filter((s) => !ours.has(key(s)));
}
